// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media screen and (min-width: 1000px) {

  .App 
  {

  margin: auto;
max-width: 1000px;
}

.menu-container
{

margin: auto;
max-width: 1000px;
}
}


/* .leaflet-control-attribution.leaflet-control a:first-child { display: none; }  */
.leaflet-attribution-flag { display: none !important;}
*,
*:focus,
*:hover {
    outline: none;
}
@media screen and (min-width: 600px) and (max-width: 1000px){

  .App 
 {

  margin: auto;
max-width: 900px;
}
.menu-container 
{

 margin: auto;
max-width: 900px;
}
}


.subtitle {
font-family: Open Sans;
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 28px; /* 140% */
}
 

@media screen and (max-width: 600px) {
  .App{
      margin-left: 0.5rem !important;
     margin-right: 0.5rem !important; 
  }
  .menu-container{
    margin-left: 0.5rem !important;
   margin-right: 0.5rem !important; 
}
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;;EAEE;;;EAGA,YAAY;AACd,iBAAiB;AACjB;;AAEA;;;AAGA,YAAY;AACZ,iBAAiB;AACjB;AACA;;;AAGA,mFAAmF;AACnF,4BAA4B,wBAAwB,CAAC;AACrD;;;IAGI,aAAa;AACjB;AACA;;EAEE;;;EAGA,YAAY;AACd,gBAAgB;AAChB;AACA;;;CAGC,YAAY;AACb,gBAAgB;AAChB;AACA;;;AAGA;AACA,sBAAsB;AACtB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B;;;AAGA;EACE;MACI,8BAA8B;KAC/B,+BAA+B;EAClC;EACA;IACE,8BAA8B;GAC/B,+BAA+B;AAClC;EACE","sourcesContent":["\n@media screen and (min-width: 1000px) {\n\n  .App \n  {\n\n  margin: auto;\nmax-width: 1000px;\n}\n\n.menu-container\n{\n\nmargin: auto;\nmax-width: 1000px;\n}\n}\n\n\n/* .leaflet-control-attribution.leaflet-control a:first-child { display: none; }  */\n.leaflet-attribution-flag { display: none !important;}\n*,\n*:focus,\n*:hover {\n    outline: none;\n}\n@media screen and (min-width: 600px) and (max-width: 1000px){\n\n  .App \n {\n\n  margin: auto;\nmax-width: 900px;\n}\n.menu-container \n{\n\n margin: auto;\nmax-width: 900px;\n}\n}\n\n\n.subtitle {\nfont-family: Open Sans;\nfont-size: 20px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 28px; /* 140% */\n}\n \n\n@media screen and (max-width: 600px) {\n  .App{\n      margin-left: 0.5rem !important;\n     margin-right: 0.5rem !important; \n  }\n  .menu-container{\n    margin-left: 0.5rem !important;\n   margin-right: 0.5rem !important; \n}\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
